<ng-container *transloco="let t; prefix: 'trip-link'">
  <div class="flex flex-col items-center gap-3">
    @if (qrSrc(); as src) {
      <img
        [src]="src"
        [alt]="t('qr-alt')"
        class="h-40 w-40"
      />
    }
    <p class="m-0 break-all text-center text-sm text-primary-text-light">{{ publicUrl() }}</p>
    <div class="flex flex-wrap justify-center gap-2">
      @if (copy() === 'link') {
        <app-button variant="secondary" size="sm" (clicked)="copyLink()">
          <fa-icon [icon]="['far', 'copy']" class="mr-2" aria-hidden="true" />
          <span>{{ t('copy') }}</span>
        </app-button>
      }
      @if (qrSrc()) {
        @if (copy() === 'image') {
          <app-button variant="secondary" size="sm" (clicked)="copyQrImage()">
            <fa-icon [icon]="['far', 'copy']" class="mr-2" aria-hidden="true" />
            <span>{{ t('copy-qr') }}</span>
          </app-button>
        }
        <app-button variant="outline" size="sm" (clicked)="downloadQr()">
          <fa-icon [icon]="['far', 'download']" class="mr-2" aria-hidden="true" />
          <span>{{ t('download-qr') }}</span>
        </app-button>
      }
    </div>
  </div>
</ng-container>
